import LoginWithButton from "../LoginwithButton";
import facebook from "./../../assets/facebook.png";
import { facebookLogin } from "./ApiService";

export default function LoginWithGoogleButton() {
  const handleLogin = async () => {
    try {
      const redirectLink = await facebookLogin();
      console.log("Login successful:", redirectLink);
      window.location.href = redirectLink;
    } catch (err) {
      console.error("Login failed:", err);
      // setError(err.message || "Login failed");
    }
  };
  return (
    <LoginWithButton
      iconimg={facebook}
      iconname="Facebook"
      onClick={handleLogin}
    />
  );
}
